import { ContentSection } from './content-section.model';
import { SearchType } from '@nrwl/rx-models';

export class ContentSectionGroup {
  id?: number;
  clinic?: number;
  name: string;
  banner?: string;
  order?: number;
  is_stock?: boolean;
  shared_on_web?: boolean;
  shared_on_app?: boolean;
  is_deleted?: boolean;
  position_after?: number;
  sections: ContentSection[];
  published_sections_count: number;
  unpublished_sections_count: number;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.clinic = data.clinic || void 0;
    this.name = data.name || void 0;
    this.banner = data.banner || void 0;
    this.order = data.order || void 0;
    this.is_stock = data.is_stock;
    this.shared_on_web = data.shared_on_web;
    this.shared_on_app = data.shared_on_app;
    this.is_deleted = data.is_deleted;
    this.position_after = data.position_after || void 0;
    this.published_sections_count = data.published_sections_count || void 0;
    this.unpublished_sections_count = data.unpublished_sections_count || void 0;
  }

  public ofType = (type: SearchType) => {
    const stock = this.is_stock === true;
    const deleted = this.is_deleted === true;

    switch (type) {
      case SearchType.GlobalLibrary:
        return stock === true && !deleted;
      case SearchType.GlobalLibraryArchive:
        return stock && deleted === true;
      case SearchType.AccountLibrary:
        return stock === false && !deleted;
      case SearchType.AccountLibraryArchive:
        return stock === false && deleted === true;
    }
    return false;
  };

  public getType() {
    const stock = this.is_stock === true;
    const deleted = this.is_deleted === true;

    if (stock === true && !deleted) {
      return SearchType.GlobalLibrary;
    }
    if (stock && deleted === true) {
      return SearchType.GlobalLibraryArchive;
    }
    if (stock === false && !deleted) {
      return SearchType.AccountLibrary;
    }
    if (stock === false && deleted === true) {
      return SearchType.AccountLibraryArchive;
    }
    return SearchType.GlobalLibrary;
  }
}

export class ContentSectionGroupPaged {
  count: number;
  previous: string;
  results: ContentSectionGroup[];

  constructor(data: any = {}) {
    this.count = data.count;
    this.previous = data.preview;
    this.results = data.results.map((item) => new ContentSectionGroup(item));
  }
}
